import AsyncStorage from '../../services/storage';
import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';

import { User } from '../../services/dataModels';
import { signOut } from '../../services/auth/Auth';

type UserState = {
  user?: User | null;
  isMockUser: boolean;
};

const initialState: UserState = {
  user: undefined,
  isMockUser: false,
};

const mockedState: UserState = {
  user: { name: 'Temp, Tim T', email: 'TTemp@mail.com' },
  isMockUser: true,
};

const logout = createAsyncThunk('users/logout', async () => {
  await signOut();
});

const clearCachedStorage = createAsyncThunk('users/clearCachedStorage', async () => {
  // MSAL and telemetry share localStorage with the app.
  await AsyncStorage.multiRemove([
    'persist:user',
    'persist:preference',
    'persist:shiftLogs',
    'preferences',
    'sites',
    'latestUpdateTime',
  ]);
});

const userSlice = createSlice({
  name: 'user',
  initialState: initialState,
  reducers: {
    mockButtonTapped: () => {
      return mockedState;
    },
    setUser: (state, { payload }: PayloadAction<User | null>) => {
      state.user = payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(logout.fulfilled, () => {
      return initialState;
    });
    builder.addCase(clearCachedStorage.fulfilled, () => {});
    builder.addCase(clearCachedStorage.rejected, () => {});
  },
});

export const actions = {
  ...userSlice.actions,
  logout,
  clearCachedStorage,
};

export default userSlice.reducer;
